import { render } from "./PlatFormCostSetting.vue?vue&type=template&id=038c0f45&scoped=true"
import script from "./PlatFormCostSetting.vue?vue&type=script&lang=js"
export * from "./PlatFormCostSetting.vue?vue&type=script&lang=js"

import "./PlatFormCostSetting.vue?vue&type=style&index=0&id=038c0f45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038c0f45"]])

export default __exports__